import {hideLoadingIndicator, receiveCourses, receivePlayers, selectPlayer, receiveCoursesFromSearch,
    receivePlayersFromSearch, createNewUserFormShowErrors, clearSearch, addPlayer, createNewUserFormHideErrors,
    createNewUserFormHideForm}
    from "./actions";
import api from '../../api';

export const createGame = form => () => (
    api.createGame.post(null, {
        course_id: form.activeCourse,
        selected_players: form.activePlayers,
    }).then((response) => {
        window.location.href = `/game/detail/${response[0].game_id}/stats/`;
    }).catch(response =>
        console.error(response), // eslint-disable-line no-console
    )
);

export const createUser = email => dispatch => (
    api.players.post(null, {
        email,
    }).then((response) => {
        dispatch(addPlayer({
            id: response.user_id,
            name: email,
            category: 'FRIENDS',
        }));
        dispatch(createNewUserFormHideErrors());
        dispatch(clearSearch());
        dispatch(createNewUserFormHideForm());
    }).catch(() => {
        dispatch(createNewUserFormShowErrors('Something went wrong... =('));
    })
);

export const fetchPlayers = query => dispatch => (
    api.players.fetch({query}, null)
        .then((response) => {
            dispatch(receivePlayers(response));

            // auto select 'me'
            const me = response.filter(p => p.category === 'ME');
            me.map(p => dispatch(selectPlayer(p)));
        }).catch((response) => {
            console.error(response); // eslint-disable-line no-console
        })
);

export const search = (activeTab, query, latitude, longitude) => (dispatch) => {
    if (!query) {
        return Promise.resolve();
    }

    if (activeTab === 'COURSE') {
        return api.searchCourses.fetch(null, {
            query,
            lat: latitude,
            lng: longitude,
        }).then((response) => {
            dispatch(receiveCoursesFromSearch(response));
            dispatch(hideLoadingIndicator());
        }).catch((response) => {
            console.error(response); // eslint-disable-line no-console
        });
    } else {
        return api.searchUsers.fetch(null, {query}).then((response) => {
            dispatch(receivePlayersFromSearch(response));
            dispatch(hideLoadingIndicator());
        }).catch((response) => {
            console.error(response); // eslint-disable-line no-console
        });
    }
};


export const fetchCourses = ({lat = null, lng = null}) => dispatch => (
    api.searchCourses.fetch(null, {lat, lng})
        .then((response) => {
            dispatch(receiveCourses(response));
            dispatch(hideLoadingIndicator());
        }).catch((response) => {
            console.error(response); // eslint-disable-line no-console
        })
);



// WEBPACK FOOTER //
// ./src/apps/create_game/thunkActions.js